import { set } from 'es-toolkit/compat';
import { isAPIError } from './data/APIUtils';

export function getFormErrors(error: unknown): Record<string, string> {
  const errors: Record<string, string> = {};

  if (!isAPIError(error)) {
    return errors;
  }

  const { details } = error;

  if (details) {
    for (const item of details) {
      if (item.loc) {
        set(errors, item.loc.slice(1), item.msg);
      }
    }
  }

  return errors;
}
